<div class="body-container">
  <div class="content_header rm_header">
    <div class="list_btn">
      <button type="button" appButton variant="primary" (click)="telechargerFichier('reglements')">
        Télécharger les règlements non rapprochés
      </button>
      <button type="button" appButton variant="primary" (click)="telechargerFichier('paiements')">
        Télécharger les paiements non rapprochés
      </button>
    </div>
  </div>
  <div class="content_body flex-1">
    <form [formGroup]="rapprochementForm" class="rapprochement-form aic jcc flex body-sub-container">
      <!-- Chaque liste porte sa recherche ; le filtrage croisé règlement / paiement est dans le service -->
      <div>
        <app-form-field label="Clients" [required]="true" class="client-element">
          <app-select
            label="Sélectionner un client"
            trigger="field"
            selectionMode="single"
            [fullWidth]="true"
            [clearable]="true"
            [options]="optionsClients()"
            [selected]="clientsSelectionnes()"
            (selectionChange)="choisirClient($event)"
          />
          @if (formulaire().controls.client.hasError('required')) {
            <span appFieldError>Le client est obligatoire</span>
          }
        </app-form-field>
      </div>

      <div>
        <!-- Recréé à chaque nouvelle liste filtrée : le sélecteur ne recharge pas de lui-même -->
        <app-form-field label="ID Règlement (Aparté)" [required]="true">
          @for (liste of [filteredReglement()]; track liste) {
            <app-async-select-dropdown
              placeholder="Sélectionner un règlement"
              [fullWidth]="true"
              [clearable]="true"
              [disabled]="formulaire().controls.reglement.disabled"
              [dataSource]="sourceReglements"
              [toOption]="optionReglement"
              [selected]="reglementSelectionne()"
              (selectionChange)="choisirReglement($event)"
              (cleared)="choisirReglement(null)"
            />
          }
          @if (formulaire().controls.reglement.hasError('required')) {
            <span appFieldError>L'id règlement est obligatoire</span>
          }
        </app-form-field>

        <app-form-field label="ID Paiement (Banque)">
          @for (liste of [filteredPaiement()]; track liste) {
            <app-async-select-dropdown
              placeholder="Sélectionner un paiement"
              [fullWidth]="true"
              [clearable]="true"
              [disabled]="formulaire().controls.paiement.disabled"
              [dataSource]="sourcePaiements"
              [toOption]="optionPaiement"
              [selected]="paiementSelectionne()"
              (selectionChange)="choisirPaiement($event)"
              (cleared)="choisirPaiement(null)"
            />
          }
        </app-form-field>
      </div>

      <div>
        <app-form-field label="Montant Règlement">
          <app-input state="readonly" [value]="montantReglement()" />
        </app-form-field>

        <app-form-field label="Montant Paiement">
          <app-input state="readonly" [value]="montantPaiement()" />
        </app-form-field>
      </div>

      <div>
        <app-form-field label="Commentaire">
          <app-input multiline [rows]="3" formControlName="commentaire" [maxLength]="200" />
          @if (
            formulaire().controls.commentaire.hasError('required') ||
            formulaire().controls.commentaire.hasError('noWhitespace')
          ) {
            <span appFieldError>Le commentaire est obligatoire</span>
          }
          @if (formulaire().controls.commentaire.hasError('maxlength')) {
            <span appFieldError>Le commentaire ne doit pas dépasser 200 caractères</span>
          }
        </app-form-field>
      </div>

      <!-- Erreurs de cohérence du formulaire entier : `app-alert` remplace les
           `mat-card` qui servaient de bandeau d'erreur. -->
      <div>
        @if (formulaire().hasError('controleMontantReglementEtPaiement') && !formulaire().hasError('controleGlobale')) {
          <app-alert variant="error">Les montants du règlement et du paiement ne correspondent pas</app-alert>
        }
        @if (formulaire().hasError('controleGlobale') && !formulaire().controls.reglement.hasError('required')) {
          <app-alert variant="error">Sélectionnez un paiement ou cochez la case non rapprochable</app-alert>
        }
      </div>

      <div>
        <app-checkbox formControlName="nonRappochable" label="Non Rapprochable" />
        <button type="submit" appButton variant="primary" (click)="openDialog()" [disabled]="formulaire().invalid">
          Valider
        </button>
      </div>
    </form>
  </div>
</div>
